<template>
   <SimpleDataCard
       :title="'Toplam Stok Tutarı'"
       :data="numberConverter(stockDetailData.leftAmount,'TRY')"
       :description="'Tüm Zamanlar'"
       :loading="stockDetailDataLoading"
       route="/management/detailed-reports"
   >
   </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapMutations, mapState} from "vuex";

export default {
  name: "ToplamStokTutari",
  components:{
    SimpleDataCard
  },
  computed:{
    ...mapState("dashboard",["stockDetailData","stockDetailDataLoading"])
  },
  methods:{
    numberConverter,
    ...mapMutations("report", ["setReportType"]),
    redirectToComponent() {
      this.setReportType("Stok Analiz Raporu");
      this.$router.push({name: "detailedReport"});
    }
  }
}
</script>

<style scoped>

</style>